import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function FamilyMembersTable({ members = [], advisorName }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  if (!members.length) {
    return (
      <div className="bg-white border border-slate-200 rounded-xl p-8 text-center text-slate-400 text-sm">
        {t('advisorPortal.familyNoLinkedMembers')}
      </div>
    );
  }
  return (
    <div className="overflow-x-auto rounded-xl border border-slate-200 bg-white">
      <table className="w-full min-w-[700px]">
        <thead>
          <tr className="bg-slate-50 border-b border-slate-200">
            <th className="px-3 py-3 text-left text-xs font-semibold text-slate-500 uppercase tracking-wide">{t('advisorPortal.familyMemberName')}</th>
            <th className="px-3 py-3 text-left text-xs font-semibold text-slate-500 uppercase tracking-wide">{t('advisorPortal.familyMemberPhone')}</th>
            <th className="px-3 py-3 text-left text-xs font-semibold text-slate-500 uppercase tracking-wide">{t('advisorPortal.familyMemberEmail')}</th>
            <th className="px-3 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide" />
          </tr>
        </thead>
        <tbody>
          {members.map((m) => (
            <tr key={m.id} className="border-b border-slate-100 last:border-0 hover:bg-slate-50/80">
              <td className="px-3 py-3 text-sm text-slate-800">{m.name || `User ${m.id}`}</td>
              <td className="px-3 py-3 text-sm text-slate-600">{m.phone || '—'}</td>
              <td className="px-3 py-3 text-sm text-slate-600">{m.email || '—'}</td>
              <td className="px-3 py-3 text-right">
                <button
                  className="inline-flex items-center gap-1 text-xs font-medium text-slate-700 border border-slate-300 px-2.5 py-1.5 rounded-md hover:bg-slate-100 transition-colors cursor-pointer whitespace-nowrap"
                  onClick={() => navigate(`/customer/${m.id}`, {
                    state: {
                      userName: m.name,
                      userId: m.id,
                      advisorName
                    }
                  })}
                >
                  {t('advisorPortal.familyMemberOpen')} <i className="ri-arrow-right-s-line text-xs" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

